module.exports = __webpack_public_path__ + "roboto-v15-latin-regular.3d3a53586bd78d1069ae.svg";


//////////////////
// WEBPACK FOOTER
// C:/Users/sung/WebstormProjects/exafe front/resources/theme/custom_omega/fonts/roboto-v15-latin-regular.svg
// module id = ../../../../../resources/theme/custom_omega/fonts/roboto-v15-latin-regular.svg
// module chunks = 2